
// import the interface

import { CrudCategorieAction, CategorieActionType } from '../actions/categorie.action';
import { Categorie } from '../models/categorie.model';
//create a dummy initial state
const initialState: Categorie[] = [];
export function categorieReducer(state: Categorie[] = initialState,action: CrudCategorieAction) {
  switch (action.type) {
    case CategorieActionType.GET_CATEGORIES:
     
      state=action.payload;
      return {
        ...state
      };

    default:
      return state;
  }
}

